import { getCurrency } from '@common/utils/currency'
import clsx from 'clsx'

import { Card, CardContent } from '@/components/ui/card'
import { Separator } from '@/components/ui/separator'
import { formatNumberWithCommas } from '@/utils/helpers'

interface TrackingStatisticsCardProps {
  linkClicks: number
  claimedFans: number
  claimedFansInLast30Days: number
  revenue: number
  revenueInLast30Days: number
  averageFanSpend: number
  renewActive: number
  totalFans: number
  isTrackingType?: boolean
  showCents?: boolean
}

const StatisticsSeparator = () => {
  return (
    <>
      <Separator
        orientation="vertical"
        className="my-auto hidden h-20 md:block"
      />
      <Separator className="mx-auto md:hidden" />
    </>
  )
}

export const TrackingStatisticsCard = ({
  linkClicks,
  claimedFans,
  claimedFansInLast30Days,
  revenue,
  revenueInLast30Days,
  averageFanSpend,
  renewActive,
  totalFans,
  isTrackingType,
  showCents,
}: TrackingStatisticsCardProps) => {
  return (
    <Card>
      <CardContent className="flex flex-col items-center justify-evenly gap-8 px-10 pt-8 md:flex-row md:items-baseline ">
        {isTrackingType && (
          <>
            <div className="flex flex-col items-center gap-2">
              <h5 className="text-center font-medium text-secondary-300">
                Link Clicks
              </h5>
              <h3 className="text-xl font-bold text-secondary-500 dark:text-white">
                {formatNumberWithCommas(linkClicks)}
              </h3>
            </div>
            <StatisticsSeparator />
          </>
        )}

        <div className="flex flex-col items-center gap-2">
          <h5 className="text-center font-medium text-secondary-300">
            Claimed Fans
          </h5>
          <h3 className="text-xl font-bold text-secondary-500 dark:text-white">
            {formatNumberWithCommas(claimedFans)}
          </h3>
          <h6 className="text-center text-secondary-300">
            {formatNumberWithCommas(claimedFansInLast30Days)} in the last 30
            days
          </h6>
        </div>

        <StatisticsSeparator />

        <div className="flex flex-col items-center gap-2">
          <h5 className="text-center font-medium text-secondary-300">
            Revenue
          </h5>
          <h3
            className={clsx(
              'text-xl font-bold',
              revenue > 0 ? 'text-success-default' : 'text-danger-default',
            )}
          >
            {getCurrency(revenue, showCents ? 2 : 0)}
          </h3>
          <h6 className="text-center text-secondary-300">
            {getCurrency(revenueInLast30Days, showCents ? 2 : 0)} in the last 30
            days
          </h6>
        </div>

        <StatisticsSeparator />

        <div className="flex flex-col items-center gap-2">
          <h5 className="text-center font-medium text-secondary-300">
            Average Fan Spend
          </h5>
          <h3 className="text-xl font-bold text-secondary-500 dark:text-white">
            {getCurrency(averageFanSpend, showCents ? 2 : 0)}
          </h3>
        </div>

        <StatisticsSeparator />

        <div className="flex flex-col items-center gap-2">
          <h5 className="text-center font-medium text-secondary-300">
            Renew Active
          </h5>
          <h3 className="text-xl font-bold text-secondary-500 dark:text-white">
            {formatNumberWithCommas(renewActive)}
          </h3>
          <h6 className="text-center text-secondary-300">
            out of {formatNumberWithCommas(totalFans)} fans
          </h6>
        </div>
      </CardContent>
    </Card>
  )
}
